import { Plugin } from "chart.js";

export const useGetVerticalLinePlugin = (
	setChartArea: (param: any) => void,
	setCoords: any,
): Plugin => {
	const chartPlugin: Plugin<"line"> = {
		id: "verticalLinePlugin",
		afterUpdate: (chart: any) => {
			if (chart.chartArea) {
				// console.log("after update");

				if (chart.mouseX === null) {
					chart.mouseX = chart.chartArea.left + chart.chartArea.width / 10;

					// chart.mouseX = chart.chartArea.left + 30.9
				}
				if (chart.secondLineX === null) {
					chart.secondLineX =
						chart.chartArea.left + chart.chartArea.width * 0.9;
					// chart.secondLineX = chart.chartArea.right
				}
			}
		},
		beforeInit(chart: any) {
			chart.mouseX = null;
			chart.secondLineX = null;
		},
		afterDatasetsDraw(chart: any) {
			const x1 = chart.mouseX;
			const x2 = chart.secondLineX;

			setChartArea(chart.chartArea);
			setCoords({ x1, x2 });
		},
	};

	return chartPlugin;
};
